<app-dialog-header [headerKey]="headerKey" [showCloseButton]="close" [ngClass]="{ lighter }">
  <ng-content custom-data select="[custom-header]"></ng-content>
</app-dialog-header>
<mat-dialog-content [ngClass]="{ lighter }">
  <ng-content select="[content]"></ng-content>
</mat-dialog-content>
<mat-dialog-actions [ngClass]="{ lighter }" class="centered">
  <ng-content select="[actions]"></ng-content>
</mat-dialog-actions>
